export default __webpack_public_path__ + "navigation-examples-route-init-v1-960-e3ad773db5524dc46c5e29e29fde3c87.png";